import React, { useEffect, useState } from "react";
import { CalendarDropdown } from "../../components/CalendarInput2";
import { getTimestampFromNow } from "../../lib/utils";
import { CardContainer, } from "../../components";

export default function CalendarTest(props) {

  const days = 0
  const _startDate = new Date(getTimestampFromNow({ now: new Date(), days: -days }))
  const [targetDate, setTargetDate] = useState(_startDate)

  useEffect(() => {
    
  }, [targetDate])

  return (
    <CardContainer>
      <CalendarDropdown
        variant="danger"
        label="날짜 선택"
        date={targetDate}
        setDate={setTargetDate}
      />

      <p>LocaleString: {targetDate.toLocaleString()}</p>
      <p>Timestamp: {new Date(targetDate).getTime()}</p>
    </CardContainer>
  )
}
